import { useAuth } from '../../context/AuthContext';
import $ from "jquery";
import { BrowserView, MobileView } from 'react-device-detect';
import './login.css'
import './style.css'
import { useTranslation } from 'react-i18next';
import { Outlet, Link } from "react-router-dom";
import axios from "axios";

import React, { useState, useEffect } from "react";


function AuthLayout() {
    const { user } = useAuth();
    const { t, i18n } = useTranslation();
    //i18n.changeLanguage("tr")
    const [logo, setLogo] = useState('');


    function onClick(event) {
        if (event.currentTarget.id === "arrow" || event.currentTarget.id === "arroww") {
            var element = document.getElementById("sidebar");
            element.classList.toggle("active");
            $(".forsidebar").toggle();
        }
        else if (event.currentTarget.id === "arrowww") {
            var element = document.getElementById("sidebar");
            element.classList.toggle("active");
            //$(".forsidebar").toggle();
        }
    }
    const getlogo = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss
            }).then(res => {
                setLogo(res.data[0])
            }
            );
        }
        catch (err) {
        }
    }
    useEffect(() => {
        getlogo();
    }, [])

    return (
        <html>
            <head>
                <title>Heryerde İngilizce</title>
            </head>
            <body style={{ backgroundColor: "white" }}>
                <nav class="main-menu d-flex navbar navbar-expand-lg p-1 py-3 p-lg-4 py-lg-2 ">
                    <div class="container-fluid">
                        <div class="main-logo d-lg-none">
                            <a href="/">
                                <img src={logo['photo']} style={{ maxWidth: "200px" }} alt="logo" class="img-fluid" />
                            </a>
                        </div>
                        <button class="navbar-toggler shadow-none" type="button">
                            <Link to="/" class="nav-link mx-2 text-decoration-underline" style={{ textAlign: "center" }}>
                                <button style={{ fontSize: "20px", borderRadius: "50px" }} type="button" class="btn btn-info">Ana Sayfa</button>
                            </Link>
                        </button>

                        <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

                            <div class="offcanvas-header mt-3">
                                <button type="button" class="btn-close shadow-none" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div class="offcanvas-body justify-content-between">
                                <div class="main-logo">
                                    <a href="/">
                                        <img src={logo['photo']} alt="logo" style={{ maxWidth: "220px", marginLeft: "20%" }} class="img-fluid" />
                                    </a>
                                </div>
                                <div class="d-none d-lg-flex align-items-center">
                                    <Link to="/ " class="nav-link mx-2 text-decoration-underline" style={{ textAlign: "center" }}>
                                        <button style={{ fontSize: "20px", borderRadius: "50px" }} type="button" class="btn btn-info">Ana Sayfa</button>
                                    </Link>
                                </div>
                            </div>
                        </div >

                    </div >
                </nav>


                <section class="vh-100">
                    <Outlet />
                </section>
            </body>
        </html>

    );

}


export default AuthLayout;
